module.exports = __webpack_public_path__ + "img/logo-compact.575b4134.png";